import { render, staticRenderFns } from "./WhoTalkAboutUs.vue?vue&type=template&id=439c6e74&"
import script from "./WhoTalkAboutUs.vue?vue&type=script&lang=js&"
export * from "./WhoTalkAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./WhoTalkAboutUs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports